import * as Yup from "yup";


  export const loginValidateSchema = Yup.object().shape({
    email: Yup.string().email("Please enter a valid email").required("This field is required"),
    password: Yup.string().required("This field is required"),
  
  });
  


  export const forgotValidateSchema = Yup.object().shape({
      email: Yup.string()
        .required("Email is required")
        .test("no-spaces", "Spaces are not allowed in email", (value) => {
          return !/\s/.test(value); // Returns false if spaces are found
        })
        .email("Invalid email format"),

  });
  

    export const otpValidateSchema = Yup.object({
      otp: Yup.string()
        .length(6, 'OTP must be exactly 6 digits')
        .required('OTP is required'),
    })




  Yup.addMethod(Yup.string, 'firstLetterUppercase', function (message) {
    return this.test('firstLetterUppercase', message, function (value) {
      const { path, createError } = this;
      return (
        value && /^[A-Z]/.test(value) || createError({ path, message })
      );
    });
  });
  
  export const CreateClassValidateSchema = Yup.object().shape({
    name: Yup.string()
      .required("This field is required").min(5, "Must be at least 5 characters")
      .max(20, "Cannot be longer than 20 characters"),
    year: Yup.string().required("This field is required"),
  });


  export const CreateTeacherValidateSchema = Yup.object().shape({


    firstName: Yup.string()
      .min(2, "Name must be at least 2 characters").max(20, "Name cannot be longer than 20 characters")
      .required("Name is required"),
    surName: Yup.string()
      .min(2, "Last name must be at least 2 characters").max(20, "Last name cannot be longer than 20 characters")
      .required("Last name is required"),

    title: Yup.string().required("This field is required"),
    email: Yup.string()
    .email("Please enter a valid email")
    .required("This field is required")
    .test('first-letter-lowercase', 'The first letter of the email must be lowercase', (value) => {
      if (!value) return true;
      return value[0] === value[0].toLowerCase();
    }),
  });



  export const CreateAdminValidateSchema = Yup.object().shape({


  
  firstName: Yup.string()
      .min(2, "Name must be at least 2 characters").max(20, "Name cannot be longer than 20 characters")
      .required("Name is required"),
    surName: Yup.string()
      .min(2, "Last name must be at least 2 characters").max(20, "Last name cannot be longer than 20 characters")
      .required("Last name is required"),
    email: Yup.string()
    .email("Please enter a valid email")
    .required("This field is required")
    .test('first-letter-lowercase', 'The first letter of the email must be lowercase', (value) => {
      if (!value) return true;
      return value[0] === value[0].toLowerCase();
    }),
  });



   export const ForgotvalidateSchema = Yup.object().shape({
    oldpassword: Yup.string().required("This field is required") ,
    newpassword:Yup.string().required("This field is required"),
    confirmedpassword:Yup.string().required("This field is required").oneOf([Yup.ref('newpassword')], 'Passwords must match') ,
  });

  export const setPassvalidateSchema = Yup.object().shape({
    newpassword:Yup.string().required("This field is required"),
    confirmedpassword:Yup.string().required("This field is required").oneOf([Yup.ref('newpassword')], 'Passwords must match') ,
  });

  
  export const TryPeerscrollerValidateSchema = Yup.object().shape({
    schoolName: Yup.string().required("School name is required"),
    name: Yup.string()
      .min(2, "Your Name must be at least 2 characters")
      .max(20, "Name cannot be longer than 20 characters")
      .required("Name is required"),
    email: Yup.string()
      .email("Please enter a valid email")
      .matches(/^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, "Please enter a valid email address")
      .required("Email is required"),
    password: Yup.string()
      .min(8, "Password must be at least 8 characters")
      .required("Password is required"),
    captchaInput: Yup.string().required("Please enter the security code"),
    agreeTerms: Yup.boolean().oneOf([true], "Please accept the trial terms."),
  });
  